const CONECTA_URL = "https://conecta.minhabiblioteca.com.br";

const Links = {
  PAGE_ACTIVATE_CODE: '/tickets/activate',
  EXTERNAL_HELP_CENTER: `${CONECTA_URL}/central-de-ajuda`,
};

export default Links;
